import { LCC, LCCPrior, LMLO, LMLOPrior, RCC, RCCPrior, RMLO, RMLOPrior } from '@common/mammoDisplaySetSelectors';
import { ServicesManager } from '@core';

export const isMammoable = (services: ServicesManager): boolean => {
	const { hangingProtocolService } = services.services;

	return [LCC, LCCPrior, LMLO, LMLOPrior, RCC, RCCPrior, RMLO, RMLOPrior].some((displaySetMatchingRule) => {
		const { matchingScores } = hangingProtocolService.matchImages(displaySetMatchingRule);
		return matchingScores && !!matchingScores.length;
	});
};
